<template>
  <div class="container-fluid">
    <div class="row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Church Activities Attendance Report
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
        <!-- <div @click="goBack">
            <span class="s-18 fw-400 cursor-pointer text-black">
              <img src="../../../assets/goback.png" alt="" /> Go back</span
            >
          </div> -->
      </div>
      <div class="c-pointer">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dak w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  class="no-decoration text-dark"
                  @click="downloadFile(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-4 border-radius-8">
      <div
        class="col-md-12 my-2"
        v-if="branchItem && branchItem.parentNames == ''"
      >
        <el-tree-select
          v-model="selectedTree"
          class="w-100 cursor-pointer"
          placeholder="Select branch"
          :data="branchMappedTree"
          :render-after-expand="false"
          :filter-node-method="filterNodeMethod"
          @change="setBranchValue"
          filterable
          check-strictly
        />
      </div>
      <div class="col-md-12">
        <div class="row align-items-center">
          <div class="col-md-9 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12 text-left text-md-center">
                <div class="mr-2 w-100 s-14 fw-400 text-dak">Date Range</div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-0">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-0">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 mt-2 mt-md-1 mb-3 mb-md-0">
                <div class="col-md-12 px-0">
                  <el-select-v2
                    v-model="selectedEventID"
                    class="w-100 font-weight-normal report-select"
                    :options="
                      allEvents.map((i) => ({
                        label: i.text,
                        value: i.id,
                      }))
                    "
                    placeholder="Select Account"
                    @change="setSelectedEvent"
                    size="medium"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="col-md-12 d-flex justify-content-end px-0">
              <el-button
                class="c-pointer report-button w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="getActivityReport()"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="element-to-print" class="">
    <div
      class="container-fluid d-flex justify-content-center my-2"
      v-if="displayTitle"
    >
      <div class="head-text">Church Activities Attendance Report</div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="w-100 mb-2">
          <h5 class="ml-3 mt-4"></h5>
          <div
            class="round-border"
            v-show="activityReport.length > 0"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <PerformanceColumnChart
              domId="chart"
              title="Attendance Analysis Chart"
              distance="5"
              :titleMargin="10"
              :data="attendanceChart"
              :series="series"
              :seriesText="`Attendance analysis`"
            />
          </div>
        </div>
        <div
          class="area-chart w-100 mt-5 lineGrap"
          v-show="activityReport.length > 0"
          :class="{ 'show-report': showReport, 'hide-report': !showReport }"
        >
          <ReportAreaChart
            elemId="chart"
            domId="areaChart1"
            title="Attendance Analysis Line Graph"
            subtitle=""
            lineColor="#50AB00"
            :xAxis="series"
            :series="attendanceData"
          />
        </div>

        <div class="w-100 mt-5">
          <h5 class="ml-3 mt-4"></h5>
          <div
            class="round-border"
            v-show="activityReport.length > 0"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <PerformanceColumnChart
              domId="chart1"
              title="Attendance Analysis Chart By Category"
              distance="5"
              :titleMargin="10"
              :data="summaryChart"
              :series="attendanceSeries"
              :seriesText="`Attendance analysis`"
            />
          </div>
        </div>
        <section class="w-100">
          <!-- table header -->
          <div class="row">
            <div
              class="col-md-12 d-flex justify-content-end"
              v-if="filteredAccount.length > 0 || searchText !== ''"
            >
              <div class="col-md-4 col-12 px-0 mt-5" v-if="!displayTitle">
                <el-input
                  v-model="searchText"
                  size="small"
                  placeholder="Search..."
                  :suffix-icon="Search"
                />
              </div>
            </div>
          </div>
          <div
            class="container-fluid table-main px-0 remove-styles2 remove-border responsiveness mb-5 mt-2"
            id="table"
            v-show="filteredAccount.length > 0"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <table
              class="table remove-styles mt-0 table-hover table-header-area"
            >
              <thead class="table-header-area-main">
                <tr
                  class="text-capitalize text-nowrap font-weight-bolder"
                  style="border-bottom: 0"
                >
                  <th scope="col">Event Name & Date</th>
                  <th scope="col">Category</th>
                  <th scope="col">Category Attendance</th>
                </tr>
              </thead>
              <tbody class="font-weight-bolder text-nowrap">
                <tr v-for="(item, index) in filteredAccount" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--end table header -->
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, nextTick, inject } from "vue";
import PerformanceColumnChart from "../../../../components/charts/ReportColumnChart.vue";
import groupData from "../../../../services/groupArray/groupResponse";
import ReportAreaChart from "../../../../components/charts/AreaChart.vue";
import axios from "@/gateway/backendapi";
import router from "../../../../router";
import { Search } from "@element-plus/icons-vue";
import dateFormatter from "../../../../services/dates/dateformatter.js";
import exportService from "../../../../services/exportFile/exportservice";
import printJS from "print-js";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";
export default {
  components: {
    PerformanceColumnChart,
    ReportAreaChart,
  },
  setup() {
    const showReport = ref(false);
    const route = useRoute();
    const loading = ref(false);
    const fileName = ref("Church Activities Attendance Report");
    const primarycolor = inject("primarycolor");
    const selectedFileType = ref({});
    const fileHeaderToExport = ref([]);
    const fileToExport = ref([]);
    const selectedTree = ref(null);
    const branchMappedTree = ref([]);
    const flattenedTree = ref([]);

    const bookTypeList = ref([
      { name: "xlsx" },
      { name: "csv" },
      { name: "txt" },
      { name: "pdf" },
    ]);
    const showExport = ref(false);
    const searchText = ref("");
    const displayTitle = ref(false);
    const allEvents = ref([]);
    const selectedEvents = ref([]);
    const series = ref([]);
    const activityReport = ref([]);
    const attendanceSeries = ref([]);
    const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
    const endDate = ref(new Date(Date.now()));
    const attendanceData = ref([]);
    const babiesData = ref([]);
    const womenData = ref([]);
    const maleData = ref([]);
    const boyData = ref([]);
    const girlData = ref([]);
    const ChildrenData = ref([]);
    const TeenagersData = ref([]);
    const SinglesData = ref([]);
    const mainAttendanceData = ref([]);
    const categoryData = ref([]);
    const attendanceGroup = ref({});
    const grousService = ref([]);
    const selectedEventID = ref(null);
    const groupedActivityService = ref([]);
    const branchItem = ref({});
    branchItem.value = JSON.parse(localStorage.getItem("branchItem"));
    // const downloadFile = (item) => {
    //   if (item.name === "pdf") {
    //     displayTitle.value = true;
    //   } else {
    //     displayTitle.value = false;
    //   }
    //   exportService.downLoadExcel(
    //     item.name,
    //     document.getElementById("element-to-print"),
    //     fileName.value,
    //     fileHeaderToExport.value,
    //     fileToExport.value
    //   );
    // };
    const downloadFile = async (item) => {
      if (item.name === "pdf") {
        displayTitle.value = true;
        await nextTick();
        exportService.downLoadExcel(
          item.name,
          document.getElementById("element-to-print"),
          fileName.value,
          fileHeaderToExport.value,
          fileToExport.value
        );
      } else {
        displayTitle.value = false;
        exportService.downLoadExcel(
          item.name,
          document.getElementById("element-to-print"),
          fileName.value,
          fileHeaderToExport.value,
          fileToExport.value
        );
      }
    };
    const buildTreeAndFlatten = (data) => {
      const tree = [];
      const flat = [];

      const map = new Map();
      data.forEach((item) => {
        const node = {
          id: item.id,
          value: item.id, // for v-model binding
          label: item.name,
          parentID: item.parentID,
          children: [],
        };
        map.set(item.id, node);
        flat.push({
          label: node.label,
          value: node.value,
          parentID: item.parentID,
        }); // for quick lookup
      });

      for (const node of map.values()) {
        if (
          !node.parentID ||
          node.parentID === "00000000-0000-0000-0000-000000000000"
        ) {
          tree.push(node);
        } else {
          const parent = map.get(node.parentID);
          if (parent) {
            parent.children.push(node);
          } else {
            tree.push(node); // orphan fallback
          }
        }
      }

      flattenedTree.value = flat;
      return tree;
    };
    const getHierarchy = async () => {
      try {
        const { data } = await axios.get(
          "/api/Branching/GetBranchesLeanInformation"
        );
        const list = data.returnObject || [];
        branchMappedTree.value = buildTreeAndFlatten(list);
      } catch (error) {
        console.log("Error loading hierarchy", error);
      }
    };
    getHierarchy();
    const setBranchValue = () => {
      const response = flattenedTree.value.find(
        (i) => i.value == selectedTree.value
      );
      // const res = allBranchDetail.value.filter(
      //   (item) => item.parentID === response.parentID
      // );
      console.log(response, "hhhhj");
    };

    const filterNodeMethod = (value, data) =>
      data.label.toLowerCase().includes(value.toLowerCase());

    const setSelectedEvent = () => {
      selectedEvents.value = allEvents.value.find(
        (i) => i.id === selectedEventID.value
      );
      console.log(selectedEvents.value, "Events");
    };

    const goBack = () => {
      router.go(-1);
    };

    const getAllEvents = () => {
      axios
        .get("/api/Reports/events/getEvents")
        .then((res) => {
          allEvents.value = res.data;
        })
        .catch((err) => console.log(err));
    };
    getAllEvents();

    const filteredAccount = computed(() => {
      if (!searchText.value.trim()) {
        return groupedActivityService.value;
      }
      return groupedActivityService.value.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchText.value.toLowerCase())
      );
    });

    const getActivityReport = () => {
      activityReport.value = [];
      const eventId = selectedEvents.value ? selectedEvents.value.id : "";
      loading.value = true;
      axios
        .get(
          `/api/Reports/events/getActivityAttendanceReport?startDate=${new Date(
            startDate.value
          ).toLocaleDateString("en-US")}&endDate=${new Date(
            endDate.value
          ).toLocaleDateString("en-US")}&activityId=${eventId}`
        )
        .then((res) => {
          activityReport.value = res.data;
          mainAttendanceData.value = [];
          attendanceData.value = [];
          series.value = [];
          groupCategory();
          groupName();
          categoryData.value = [];
          getActivityServices();
          setTimeout(() => {
            fileHeaderToExport.value = exportService.tableHeaderToJson(
              document.getElementsByTagName("th")
            );
            fileToExport.value = exportService.tableToJson(
              document.getElementById("table")
            );
          }, 1000);
          showReport.value = true;
          loading.value = false;

          if (activityReport.value.length === 0) {
            ElMessage({
              type: "warning",
              showClose: true,
              message: "No data for this date range",
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          loading.value = false;
        });
    };

    const groupCategory = () => {
      attendanceGroup.value = groupData.groupData(
        activityReport.value,
        "attendanceCategory"
      );
      const dateSeries = groupData.groupData(activityReport.value, "date");
      for (const prop in dateSeries) {
        attendanceSeries.value.unshift(dateFormatter.monthDayYear(prop));
      }
    };
    const groupName = () => {
      const result = groupData.groupData(activityReport.value, "name");
      for (const prop in result) {
        grousService.value.push({
          name: prop,
          value: result[prop],
        });
      }

      grousService.value.forEach((i) => {
        i.value.forEach((j) => {
          groupedActivityService.value.push({
            name: i.name.split(",").join(""),
            category: j.attendanceCategory,
            amount: j.attendance,
          });
        });
      });
    };

    const attendanceChart = computed(() => {
      if (activityReport.value.length === 0) return [];
      activityReport.value.forEach((i) => {
        let attendanceIndex = Object.keys(i).findIndex(
          (i) => i === "attendance"
        );
        let attendanceValue = Object.values(i)[attendanceIndex];
        attendanceData.value.unshift(attendanceValue);
      });

      mainAttendanceData.value.push({
        name: "Attendance",
        color: "#f94144",
        data: attendanceData.value,
      });
      return mainAttendanceData.value;
    });
    const getActivityServices = () => {
      activityReport.value.forEach((i) => {
        let serviceIndex = Object.keys(i).findIndex((i) => i === "date");
        let serviceValue = Object.values(i)[serviceIndex];
        series.value.unshift(dateFormatter.monthDayYear(serviceValue));
      });
    };

    const summaryChart = computed(() => {
      if (Object.keys(attendanceGroup.value).length === 0) return new Object();
      Object.entries(attendanceGroup.value).forEach(([key, value]) => {
        let newArr = [];
        value.forEach((i) => {
          let valIndex = Object.keys(i).findIndex((i) => i === "attendance");
          let attValue = Object.values(i)[valIndex];
          newArr.unshift(attValue);
        });
        categoryData.value.push({
          name: key,
          color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
          data: newArr,
        });
      });
      //     attendanceGroup.value.Babies ? attendanceGroup.value.Babies.forEach(i => {
      //     let babiesIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let babiesValue = Object.values(i)[babiesIndex]
      //     babiesData.value.unshift(babiesValue)
      //     console.log(babiesData.value)
      // }) : []

      //  categoryData.value.push({
      //         name: 'Babies',
      //         color: '#3f37c9',
      //         data: babiesData.value
      //     })

      //    attendanceGroup.value.FeMale ? attendanceGroup.value.FeMale.forEach(i => {
      //     let womenIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let womenValue = Object.values(i)[womenIndex]
      //     womenData.value.unshift(womenValue)

      // }) : []

      //  categoryData.value.push({
      //         name: 'Women',
      //         color: '#43eb10',
      //         data: womenData.value
      //     })
      //     attendanceGroup.value.Male ? attendanceGroup.value.Male.forEach(i => {
      //     let maleIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let maleValue = Object.values(i)[maleIndex]
      //     maleData.value.unshift(maleValue)
      //     console.log(maleData)
      // }) : []

      //  categoryData.value.push({
      //         name: 'male',
      //         color: '#a207f0',
      //         data: maleData.value
      //     })

      //     attendanceGroup.value.Boy ? attendanceGroup.value.Boy.forEach(i => {
      //     let boyIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let boyValue = Object.values(i)[boyIndex]
      //     boyData.value.unshift(boyValue)
      // }) : []

      //  categoryData.value.push({
      //         name: 'Boy',
      //         color: '#e7f20c',
      //         data: boyData.value
      //     })
      //     attendanceGroup.value.Girl ? attendanceGroup.value.Girl.forEach(i => {
      //     let girlIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let girlValue = Object.values(i)[girlIndex]
      //     girlData.value.unshift(girlValue)

      // }) : []

      //  categoryData.value.push({
      //         name: 'Girl',
      //         color: '#818182',
      //         data: girlData.value
      //     })

      //      attendanceGroup.value.Children ?  attendanceGroup.value.Children.forEach(i => {
      //     let ChildrenIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let ChildrenValue = Object.values(i)[ChildrenIndex]
      //     ChildrenData.value.unshift(ChildrenValue)
      //     console.log(ChildrenData)
      // }) : []
      //  categoryData.value.push({
      //         name: 'Children',
      //         color: '#ed6109',
      //         data: ChildrenData.value
      //     })
      //      attendanceGroup.value.Teenagers ? attendanceGroup.value.Teenagers.forEach(i => {
      //     let TeenagersIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let TeenagersValue = Object.values(i)[TeenagersIndex]
      //    TeenagersData.value.unshift(TeenagersValue)
      // }) : []

      //  categoryData.value.push({
      //         name: 'Teenagers',
      //         color: '#b01105',
      //         data: TeenagersData.value
      //     })

      //     attendanceGroup.value.singles ? attendanceGroup.value.singles.forEach(i => {
      //     let SinglesIndex = Object.keys(i).findIndex(i => i === 'attendance')
      //     let SinglesValue = Object.values(i)[SinglesIndex]
      //    SinglesData.value.unshift(SinglesValue)
      // }) : []
      //  categoryData.value.push({
      //         name: 'Singles',
      //         color: '#f7d68f',
      //         data: SinglesData.value
      //     })

      return categoryData.value;
    });

    const formatDate = (date) => {
      return dateFormatter.monthDayYear(date);
    };

    return {
      setBranchValue,
      filterNodeMethod,
      branchMappedTree,
      selectedTree,
      flattenedTree,
      route,
      branchItem,
      formatDate,
      Search,
      filteredAccount,
      searchText,
      loading,
      primarycolor,
      startDate,
      endDate,
      selectedEvents,
      displayTitle,
      allEvents,
      activityReport,
      getActivityReport,
      series,
      attendanceSeries,
      attendanceChart,
      womenData,
      maleData,
      setSelectedEvent,
      selectedEventID,
      boyData,
      girlData,
      ChildrenData,
      TeenagersData,
      SinglesData,
      attendanceData,
      mainAttendanceData,
      categoryData,
      babiesData,
      summaryChart,
      attendanceGroup,
      grousService,
      showExport,
      printJS,
      downloadFile,
      goBack,
      bookTypeList,
      selectedFileType,
      fileHeaderToExport,
      fileToExport,
      fileName,
      showReport,
      groupedActivityService,
    };
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 400 !important;
  color: #000000 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #f4f4f4;
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.round-border {
  border-radius: 0.5rem;
  box-shadow: 0 0.063rem 0.25rem #02172e45;
  border: 0.063rem solid #dde2e6;
}

.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  border: 0.063rem solid #dde2e6 !important;
  border-radius: 30px !important;
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}
.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.remove-border {
  box-shadow: none !important;
}
.tablerow-style {
  min-width: 100%;
  border-bottom: 0px;
}

.graph-area {
  border: 1px solid #dde2e6;
  border-radius: 0.5rem;
  padding: 1rem 0rem;
  margin: 2rem 0rem;
}

.responsiveness {
  max-width: 100%;
  overflow-y: scroll;
}

.p-multiselect {
  width: 18rem;
}

.multiselect-custom {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.country-item-value {
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: 0.5rem;
  /* background-color:  */
  /* background-color: var(--primary-color); */
  /* color: var(--primary-color-text); */
}
.border {
  border-color: #b0b2b5 !important;
  border-radius: 15px !important;
}
.lineGrap {
  border-radius: 0.5rem;
  box-shadow: 0 0.063rem 0.25rem #02172e45;
  border: 0.063rem solid #dde2e6;
  font-weight: bold;
}
.borderInner {
  width: 100%;
  /* height: 700px; */
}
img.flag {
  width: 17px;
}
.primary-bg {
  background-color: rgb(19, 106, 205) !important;
  border-style: none !important;
}
.p-button.p-button-icon-only {
  background-color: red !important;
}

@media screen and (max-width: 640px) {
  .p-multiselect {
    width: 100%;
  }
}
</style>
